import React from 'react';

const Admin = () => (
  <p>Admin</p>
);

export default Admin;
